const iconsData = {
  'React.js': 'http://formatjs.io/img/react.svg',
  'Node.js': 'https://cdn2.iconfinder.com/data/icons/nodejs-1/512/nodejs-512.png',
  express: 'https://cdn2.iconfinder.com/data/icons/nodejs-1/512/nodejs-512.png',
  PostgreSQL: 'http://tapoueh.org/images/220px-Postgresql_elephant.svg.png',
  'socket.io': 'https://www.pubnub.com/blog/wp-content/uploads/2014/07/SOCKETIOICON.gif',
  Ionic: 'http://uxrepo.com/static/icon-sets/ionicons/svg/ionic.svg',
  AngularJS: 'https://lh6.googleusercontent.com/-TlY7amsfzPs/T9ZgLXXK1cI/AAAAAAABK-c/Ki-inmeYNKk/w800-h800/AngularJS-Shield-large.png',
  MongoDB: 'http://www.todobackend.com/images/logos/mongodb.png',
  neo4j: 'https://avatars3.githubusercontent.com/u/218965?v=3&s=200',
  'd3.js': 'https://upload.wikimedia.org/wikipedia/en/thumb/1/15/Logo_D3.svg/1079px-Logo_D3.svg.png',
  Leaflet: 'http://leafletjs.com/docs/images/logo.png',
  Redux: 'https://rawgit.com/gorangajic/react-icons/master/react-icons.svg',
  RethinkDB: 'https://api.jujucharms.com/charmstore/v4/~adam-stokes/trusty/rethinkdb-slave-4/icon.svg',
  Docker: 'https://d3oypxn00j2a10.cloudfront.net/0.7.0/img/homepage/docker-whale-home-logo.png',
  Webpack: 'https://camo.githubusercontent.com/d18f4a7a64244f703efcb322bf298dcb4ca38856/68747470733a2f2f7765627061636b2e6a732e6f72672f6173736574732f69636f6e2d7371756172652d6269672e737667',
  Sass: 'http://sass-lang.com/assets/img/styleguide/seal-color-aef0354c.png',
  Firebase: 'https://firebase.google.com/_static/images/firebase/touchicon-180.png',
  Puyo: 'http://puyopuyoquest.sega-net.com/renewal_cp/image/puyo-g.png',
  Javascript: 'https://cdn2.iconfinder.com/data/icons/nodejs-1/512/nodejs-512.png',
  Python: 'https://www.python.org/static/opengraph-icon-200x200.png',
  SQL: 'https://milinaudara.files.wordpress.com/2014/05/logo.png',
  Japanese: 'http://livedoor.blogimg.jp/worldfusigi/imgs/a/8/a8d89ace.jpg',
  Portapros: 'https://www.koss.com/media/catalog/product/p/o/porta_pro_product_glamor_shot_image.jpg',
  Books: 'https://openclipart.org/image/2400px/svg_to_png/275692/1489798288.png',
  Noodles: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Twemoji_1f35c.svg/1000px-Twemoji_1f35c.svg.png',
  Family: 'http://pds.exblog.jp/pds/1/201412/22/62/c0117762_7193163.png',
  Fullstack: 'https://pbs.twimg.com/profile_images/694191024416112642/VtJUhbKk.png',
  Potato: 'https://visualpharm.com/assets/930/Potato-595b40b65ba036ed117d31c3.svg'
};

export { iconsData };



// WEBPACK FOOTER //
// ./src/data/techStackIcons.js